/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Incidents API
 * AV Services Incidents management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  IncidentStatisticsResponseDto,
  IncidentsControllerFindAllResolvedV1200AllOf,
  IncidentsControllerFindAllResolvedV1Params,
  IncidentsControllerFindAllResolvedV1PathParameters,
  IncidentsControllerFindAllV1200AllOf,
  IncidentsControllerFindAllV1Params,
  IncidentsControllerFindAllV1PathParameters,
  IncidentsControllerFindOneByIdV1200,
  IncidentsControllerFindOneByIdV1PathParameters,
  IncidentsControllerGetStatisticsV1Params,
  IncidentsControllerGetStatisticsV1PathParameters,
  IncidentsControllerUpdateIncidentV1200,
  IncidentsControllerUpdateIncidentV1PathParameters,
  UpdateIncidentDto,
} from '../models';

@Injectable({ providedIn: 'root' })
export class IncidentsService {
  private readonly http = inject(HttpClient);
  /**
   * @summary Update an incident by Super Admin
   */

  updateIncident<TData = IncidentsControllerUpdateIncidentV1200>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, incidentId }: IncidentsControllerUpdateIncidentV1PathParameters,
    updateIncidentDto: UpdateIncidentDto,
  ): Observable<TData> {
    return this.http.patch<TData>(`/incidents/v1/clients/${clientId}/incidents/${incidentId}`, updateIncidentDto);
  }

  findOneById<TData = IncidentsControllerFindOneByIdV1200>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    incidentId,
  }: IncidentsControllerFindOneByIdV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/incidents/v1/clients/${clientId}/incidents/${incidentId}`);
  }

  findAll<TData = IncidentsControllerFindAllV1200AllOf>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: IncidentsControllerFindAllV1PathParameters,
    params?: IncidentsControllerFindAllV1Params,
  ): Observable<TData> {
    return this.http.get<TData>(`/incidents/v1/clients/${clientId}/incidents/open`, {
      params: (() => {
        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }

  findAllResolved<TData = IncidentsControllerFindAllResolvedV1200AllOf>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: IncidentsControllerFindAllResolvedV1PathParameters,
    params?: IncidentsControllerFindAllResolvedV1Params,
  ): Observable<TData> {
    return this.http.get<TData>(`/incidents/v1/clients/${clientId}/incidents/resolved`, {
      params: (() => {
        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
  /**
   * Returns aggregated statistics for incidents based on the provided filters.
   * @summary Get incident statistics
   */

  getStatistics<TData = IncidentStatisticsResponseDto>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: IncidentsControllerGetStatisticsV1PathParameters,
    params?: IncidentsControllerGetStatisticsV1Params,
  ): Observable<TData> {
    return this.http.get<TData>(`/incidents/v1/clients/${clientId}/incidents/statistics`, {
      params: (() => {
        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
}
